<template>
    <table class="table mb-0 table-hover table-bordered bulk-table">
        <thead class="thead-light">
            <tr>
                <th style="width: 20%;">{{ $t('bulk_form.date') }}</th>
                <th style="width: 40%;">{{ $t('bulk_form.name') }}</th>
                <th class="text-center" style="width: 15%;">{{ $t('bulk_form.price') }}</th>
                <th class="text-right" style="width: 25%;">{{ $t('bulk_form.ticket') }}</th>
            </tr>
        </thead>
        <tbody>
            <bulk-row
                v-for="registrationCategory in registrationCategories"
                :key="registrationCategory.id"
                :registration-category="registrationCategory"
                :value="getQuantity(registrationCategory.id)"
                @input="updateQuantity(registrationCategory.id, $event)"
                :disabled="disabled"
                :top-up-bulk-action="topUpBulkAction"
            ></bulk-row>
        </tbody>
    </table>
</template>

<script>
import BulkRow from './BulkRow';

export default {
    name: "BulkTableContainer",
    components: {
        BulkRow,
    },
    props: {
        registrationCategories: {
            type: Array,
            required: true,
            default: () => []
        },
        value: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: false
        },
        topUpBulkAction: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getQuantity(rcId) {
            return this.value[rcId] || 0;
        },
        updateQuantity(rcId, quantity) {
            const updatedTickets = { ...this.value };
            updatedTickets[rcId] = quantity;
            this.$emit('input', updatedTickets);
        }
    }
}
</script>

<style scoped>
.bulk-table {
    overflow: hidden;
    border: none !important;
    border-right: 1px solid #e8e8e8 !important;
}

.bulk-table thead th {
    font-weight: 600;
    font-size: 0.75rem;
    color: #495057;
    background-color: #f8f9fa;
    border: none;
    border-right: 1px solid #e8e8e8;
    padding: 1rem 1.25rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.bulk-table thead th:last-child {
    border-right: none;
}

.bulk-table tbody tr {
    transition: background-color 0.2s ease;
}

.bulk-table tbody tr:hover {
    background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Table/BulkTableContainer.vue